import { z } from "zod";
export const SMS_TEMPLATE_KEYS = [
    "booking.payment-captured",
    "booking.reminder",
    "booking.cancelled",
    "queue.called",
    "mail.bag-received",
    "mail.quoted",
    "mail.payment-captured",
    "mail.return-payment",
    "mail.return-payment-paid",
];
export const smsTemplateKeySchema = z.enum(SMS_TEMPLATE_KEYS);
export const updateSmsTemplatesSchema = z.object({
    templates: z.record(smsTemplateKeySchema, z.string().min(1).max(320)),
});
export const listSmsTemplatesResponseSchema = z.object({
    items: z.array(z.object({
        key: smsTemplateKeySchema,
        body: z.string(),
        isCustom: z.boolean(),
        default: z.string(),
    })),
});
export const updateSmsTemplatesResponseSchema = z.object({ updated: z.number() });
export const retryOutboxTaskResponseSchema = z.object({ retried: z.literal(true) });
